export default "__VITE_ASSET__c4b13f67__"